import Phaser from 'phaser';
import { THEME } from '@/config/theme';
import { BACKGROUNDS } from '@/config/settings';
import { MORSE_SPACING } from '@/utils/timing';

export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'BootScene' });
  }

  preload(): void {
    // Create loading bar
    const width = this.cameras.main.width;
    const height = this.cameras.main.height;

    const progressBar = this.add.graphics();
    const progressBox = this.add.graphics();
    progressBox.fillStyle(THEME.colors.backgroundLightHex, 0.8);
    progressBox.fillRect(width / 2 - 160, height / 2 - 25, 320, 50);

    const loadingText = this.add.text(width / 2, height / 2 - 50, 'Loading...', {
      fontFamily: THEME.fonts.pixel,
      fontSize: THEME.sizes.body,
      color: THEME.colors.text,
    });
    loadingText.setOrigin(0.5, 0.5);

    const percentText = this.add.text(width / 2, height / 2, '0%', {
      fontFamily: THEME.fonts.pixel,
      fontSize: THEME.sizes.small,
      color: THEME.colors.text,
    });
    percentText.setOrigin(0.5, 0.5);

    // Loading progress events
    this.load.on('progress', (value: number) => {
      progressBar.clear();
      progressBar.fillStyle(THEME.colors.primaryHex, 1);
      progressBar.fillRect(width / 2 - 150, height / 2 - 15, 300 * value, 30);
      percentText.setText(`${Math.round(value * 100)}%`);
    });

    this.load.on('complete', () => {
      progressBar.destroy();
      progressBox.destroy();
      loadingText.destroy();
      percentText.destroy();
    });

    // Load assets
    for (const bg of BACKGROUNDS) {
      this.load.image(`bg-${bg.id}`, bg.file);
    }
    this.load.audio('morse', 'assets/audio/dash_dot.ogg');
    this.load.audio('ambient', 'assets/audio/ambient.ogg');
  }

  create(): void {
    // Generate sprites programmatically
    this.createSprites();

    // Proceed to menu
    this.scene.start('MenuScene');
  }

  private createSprites(): void {
    // Dot sprite
    const dotGraphics = this.make.graphics({ x: 0, y: 0 });
    dotGraphics.fillStyle(THEME.colors.primaryHex, 1);
    dotGraphics.fillRect(0, 0, MORSE_SPACING.dotWidth, MORSE_SPACING.noteHeight);
    dotGraphics.generateTexture('dot-sprite', MORSE_SPACING.dotWidth, MORSE_SPACING.noteHeight);
    dotGraphics.destroy();

    // Dash sprite
    const dashGraphics = this.make.graphics({ x: 0, y: 0 });
    dashGraphics.fillStyle(THEME.colors.primaryHex, 1);
    dashGraphics.fillRect(0, 0, MORSE_SPACING.dashWidth, MORSE_SPACING.noteHeight);
    dashGraphics.generateTexture('dash-sprite', MORSE_SPACING.dashWidth, MORSE_SPACING.noteHeight);
    dashGraphics.destroy();
  }
}
